// @flow

import React from 'react';
import type { ColorScheme } from '../../../types/theme';
import Title from './title';
import SubTitle from './subTitle';

type Props = {
  scheme: ColorScheme,
  title?: ?string,
  subtitle?: ?string,
};

const ListHeader = ({ scheme, title, subtitle }: Props) => (
  <header>
    {title && (
      <Title scheme={scheme}>{title}</Title>
    )}
    {subtitle && (
      <SubTitle scheme={scheme}>{subtitle}</SubTitle>
    )}

  </header>
);

ListHeader.defaultProps = {
  title: null,
  subtitle: null,
};

export default ListHeader;
